import * as views from "./views.style";

/**
 * Mergea las exports nombradas de views.style en un único objeto plano.
 * Evita cualquier referencia a `default` para no activar la comprobación estática de webpack.
 */
const resolvedViews = Object.keys(views).reduce((acc, key) => {
  if (key === "__esModule") return acc;
  (acc as any)[key] = (views as any)[key];
  return acc;
}, {} as Record<string, any>);

export default resolvedViews;
export { resolvedViews as viewsStyles };